var exports = {
  "k": "x234b8571--d1f1bd--container",
  "_": "x234b8571--d1f1bd--stretch",
};

module.exports = exports;
